import actionTypes from './actionTypes1';
import getActionCreator from '../libs/getActionCreator';

export const setTable = getActionCreator(actionTypes.SET_TABLE);
export const setLegenda = getActionCreator(actionTypes.SET_LEGENDA);
export const setSituation = getActionCreator(actionTypes.SET_SITUATION);
export const setFirstPairCardTableFold = getActionCreator(actionTypes.SET_FIRST_PAIR);
export const setSecondPairCardTableFold = getActionCreator(actionTypes.SET_SECOND_PAIR);

export const setCard1 = (payload) => ({
  type: actionTypes.SET_CARD1,
  payload,
});

export const setCard2 = (payload) => ({
  type: actionTypes.SET_CARD2,
  payload,
});

export const setCard3 = (payload) => ({
  type: actionTypes.SET_CARD3,
  payload,
});

export const setCard4 = (payload) => ({
  type: actionTypes.SET_CARD4,
  payload,
});

export const setSuit = (payload) => ({
  type: actionTypes.SET_SUIT,
  payload,
});

export const setGgps = (payload) => ({
  type: actionTypes.SET_GGPS,
  payload,
});

export const setSuitQuality = (payload) => ({
  type: actionTypes.SET_SUIT_QUALITY,
  payload,
});

export const setBB = (payload) => ({
  type: actionTypes.SET_BB,
  payload,
});

export const setTS = (payload) => ({
  type: actionTypes.SET_TS,
  payload,
});

export const setStake = (payload) => ({
  type: actionTypes.SET_STAKE,
  payload,
});
